import { ImportUsersDto } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';

class FormValues extends ImportUsersDto {
  file: File;
}

export class ImportUsersService {
	private readonly baseRoute = 'import-users';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async importUsers(data: FormValues): Promise<void> {
		return this.httpClient.post(`${this.baseRoute}/csv`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	}
}

export default ImportUsersService;
